module.exports = __webpack_public_path__ + "assets/img/The-Dream-Collective-Website-w720.241716fd.webp";